(() => {
  const footer = document.querySelector('[data-tw-content="events"] .tw-events-share-footer');
  if (!footer || footer.dataset.keyboardBound) return;
  footer.dataset.keyboardBound = 'true';
  const labels = { twitter: 'Xで共有', facebook: 'Facebookで共有', sharethis: 'その他の方法で共有' };
  const prepare = () => footer.querySelectorAll('.st-btn[data-network]').forEach(button => {
    const label = labels[button.dataset.network];
    if (!label) return;
    button.tabIndex = 0;
    button.setAttribute('role', 'button');
    button.setAttribute('aria-label', label);
  });
  new MutationObserver(prepare).observe(footer, { childList: true, subtree: true });
  prepare();
  footer.addEventListener('keydown', event => {
    const button = event.target.closest('.st-btn[data-network]');
    if (button && footer.contains(button) && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      button.click();
    }
  });
})();
